import React from 'react';

interface PlayButtonProps {
  isPlaying: boolean;
  mediaElementId: string;
  onClick: () => void;
}

export const PlayButton = React.memo(function PlayButton({ isPlaying, mediaElementId, onClick }: PlayButtonProps) {
  return (
    <button
      className={`kollab-player-btn kollab-player-play-btn ${isPlaying ? 'kollab-player-play-btn--playing' : ''}`}
      aria-label={isPlaying ? 'Pause' : 'Play'}
      data-tooltip={isPlaying ? 'Pause' : 'Play'}
      aria-controls={mediaElementId}
      onClick={onClick}
      type="button"
    >
      <span className="kollab-player-btn-icon" aria-hidden="true" />
    </button>
  );
});
